import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

import { environment } from '../../../../../../environments/environment'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { BreadcrumbLink } from '../../../../../shared/interfaces/breadcrumb-link.interface'
import { StripHtmlPipe } from '../../../../../shared/pipes/strip-html.pipe'
import { TruncatePipe } from '../../../../../shared/pipes/truncate.pipe'
import { BreadcrumbService } from '../../../../../shared/services/breadcrumb.service'
import { MetaService } from '../../../../../shared/services/meta.service'
import { MetricUseCase } from '../../../interfaces/metric-use-case.interface'
import { MetricUseCaseService } from '../../../services/metric-use-case.service'
import { sidebarTaxonomies } from '../../sidebar-taxonomies.content'

@Component({
  selector: 'app-metric-use-case-detail',
  templateUrl: './metric-use-case-detail.component.html',
  styleUrls: ['./metric-use-case-detail.component.scss']
})
export class MetricUseCaseDetailComponent implements OnInit {
  metricUseCase: MetricUseCase

  sidebarTaxonomies: {
    label: string
    propName: string
    queryParamName?: string
  }[] = sidebarTaxonomies

  breadcrumbLinks: BreadcrumbLink[] = []

  showReportMetricUseCaseModal = false
  ResourceSlug = ResourceSlug

  constructor(
    private activatedRoute: ActivatedRoute,
    private metricUseCaseService: MetricUseCaseService,
    private breadcrumbService: BreadcrumbService,
    private metaService: MetaService,
    private stripHtmlPipe: StripHtmlPipe,
    private truncatePipe: TruncatePipe,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.metricUseCaseService.show(params.slug).then(
        (mucRes: MetricUseCase) => {
          this.metricUseCase = mucRes

          this.metaService.setTags({
            title: this.metricUseCase.name,
            description: this.truncatePipe.transform(
              this.stripHtmlPipe.transform(this.metricUseCase.content),
              [160]
            ),
            path: `metric-use-cases/${this.metricUseCase.slug}`,
            absoluteOgImage:
              environment.baseUrl + 'assets/images/catalogue-og-image.png'
          })

          this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
            'toolCatalog',
            [
              {
                label: 'Metric Use Cases',
                path: `/catalogue/metric-use-cases/`
              },
              {
                label: this.metricUseCase.name,
                path: `/catalogue/metric-use-cases/${this.metricUseCase.slug}`
              }
            ]
          )
        },
        () => {
          this.router.navigate(['/404'])
        }
      )
    })
  }
  goToFilteredList(queryParamName: string, queryParamValue: string) {
    this.router.navigate(['/catalogue/metric-use-cases'], {
      queryParams: {
        [queryParamName]: queryParamValue
      }
    })
  }
}
